import React from "react";
import { Spinner } from "react-bootstrap";

const BtnSpinner = ({ text = "Loading...", size = "sm", animation = "grow" }) => (
    <span className="d-inline-flex align-items-center gap-1">
        <Spinner
            as="span"
            animation={animation}
            size={size}
            role="status"
            aria-hidden="true"
        />
        {text}
    </span>
);

export default React.memo(BtnSpinner);